<template>
  <div class="banner-container">
    <div class="page-banner-part">
      <div class="banner-text-wrapper">
        <div class="banner-text">
          <h2 class="title"> {{ $t('BONUSCLOUD')}}</h2>
          <p class="desc">{{ $t('detail')}}</p>
        </div>
      </div>
      <div class="page-banner-wrapper">
        <img src="../../assets/pagebanner/banner_pc.png" />
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "WHITEPAPER": "WHITEPAPER",
    "BONUSCLOUD": "BONUSCLOUD",
    "detail": "The universally-carried fog computing platform in the world"
  },
  "zn": {
    "WHITEPAPER": "白皮书",
    "BONUSCLOUD": "BONUSCLOUD",
    "detail": "全球泛载雾计算平台"
  }
}
</i18n>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "BannerContainer",
  props: {},  
  data() {
    return {};
  },
  computed: mapState({
    isZnWebsite: state => state.isZnWebsite,
  }),
  created() {
    this.$i18n.locale = this.isZnWebsite ? "zn" : "en";
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.page-banner-part {
  position: relative;
  padding: 0 0 120px;

  .page-banner-wrapper {
    display: block;
    margin: 0 auto;
    width: 49%;
    padding: 2% 0;

    img {
      display: block;
      margin: 0 auto;
      width: 100%;
      max-width: 800px;
      transform: rotate(0deg) skew(0deg) scale(1);
      -ms-transform: rotate(0deg) skew(0deg) scale(1); /* IE 9 */
      -moz-transform: rotate(0deg) skew(0deg) scale(1); /* Firefox */
      -webkit-transform: rotate(0deg) skew(0deg) scale(1); /* Safari ºÍ Chrome */
      -o-transform: rotate(0deg) skew(0deg) scale(1);
      animation: rotate 50s linear infinite;
      -webkit-animation: rotate 50s linear infinite;
      -moz-animation: rotate 50s linear infinite;
      -o-animation: rotate 50s linear infinite;
    }
  }

  .banner-text-wrapper {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #fff;
    letter-spacing: 3px;

    .banner-text {
      text-align: center;
      margin-top: -120px;
      z-index: 1000;
    }

    .title {
      font-size: 60px;
      margin-bottom: 20px;
      letter-spacing: 8px;
      display: block;
    }

    .desc {
      font-size: 18px;
      font-weight: 500;
      line-height: 1.5;
      letter-spacing: 5px;
      opacity: 0.8;
      display: block;
    }
  }

  a.whitepaper-button {
    font-size: 12px;
    padding: 15px 20px;
    letter-spacing: 2px;
    border: 1px solid #fff;
    color: #fff;
    display: block;
    width: 200px;
    margin: 50px auto;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(360deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

@media (max-width: 720px) {
  .page-banner-part {
    padding-bottom: 60px;

    .page-banner-wrapper {
      width: 100%;

      img {
        animation: none;
      }
    }

    .banner-text-wrapper {
      .banner-text {
        letter-spacing: 2px;
        margin-top: -50px;
      }

      .title {
        font-size: 24px;
        margin-bottom: 12px;
        letter-spacing: 5px;
      }

      .desc {
        width: 89%;
        margin: 0 auto;
      }
    }

    .sign-activity {
      display: none;
    }
  }
}
</style>
